export interface User {
  id: string;
  email: string;
  handle: string;
  fullName: string;
  mapShareId: string | null;
  privacy: Privacy;
}

export interface CreateUserInput extends Omit<User, "id"> {
  password: string;
  mapSharePassword: string | null;
}

export interface WithUserId {
  userId: string;
}

export interface WithEmail {
  email: string;
}

export enum Privacy {
  Public = "Public",
  FollowersOnly = "FollowersOnly",
  FollowBackOnly = "FollowBackOnly",
}

export interface UpdateUserProfileAttributesInput
  extends Pick<User, "fullName">, WithUserId {}

export interface UserMapShareLink {
  mapShareId: string | null;
  mapSharePassword: string | null;
}

export interface UpdateUserPrivacyInput extends WithUserId {
  privacy: Privacy;
}

export interface UserSummary extends Omit<User, "email"> {}
